import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .historyImg{
    width: 15px;
    height: 13px;
    margin-right: 6px;
  }

  p{
    color: #0E4C54;
    font-weight: 400;
  }

  & em {
    font-weight: 900;
    font-style: normal;
  }

`;

export const Title = styled.h1`
  font-size: 12px;
  font-weight: 400;
  color: #0E4C54;
`;

export const FactoryPrice = styled.div`
  display: grid;
  grid-template-columns: 1fr 85px;
  grid-template-rows: 1fr;
  justify-items: flex-end;
  margin-top: 1rem;

  .line {
    width: 100%;
    height: auto;
    border-bottom: 1px solid #BEBEBE
  }

  .price-info {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 12px;
      font-weight: 700;
      color: #364863;

      display: flex;
      justify-content: flex-end;
    }
    
    span {
      font-size: 12px;
      font-weight: 400;
      color: #364863;

      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const SectionTitle = styled.h2`
  margin-top: 1rem;
  font-size: 12px;
  font-weight: 400;
  color: #858585;

  display: flex;
  align-items: flex-start;
`;

export const CDGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  justify-items: flex-start;
`;

export const CDItem = styled.div`
  text-align: center;
  font-size: 12px;

  div:nth-child(1) {
    font-weight: 700;
    color: #364863;

    display: flex;
    align-items: flex-start;
  }

  div:nth-child(2) {
    font-weight: 400;
    color: #364863;

    display: flex;
    align-items: flex-start;
  }
`;

export const Details = styled.div`
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #BEBEBE;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
`;

export const Column = styled.div`
  flex: 1;

  div {
    font-size: 12px;
    line-height: 1.5;
    display: flex;
  }
`;

export const TextDetail = styled.div<{ faded?: boolean }>`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) => (props.faded ? '#858585' : '#364863')};
`;

export const CustomValue = styled.div<{ textValue?: boolean }>`
  color: #364863;
  font-weight: ${(props) => (props.textValue ? '700' : '400')};
`;